// @ts-nocheck
/* eslint-disable */
export const flMainMenuMoreIcon = {
    data: `<svg viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 6.53845H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 12.0769H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'main-menu-more' as const
};